import React, { useEffect, useState } from 'react';
import { Button, Modal, Form, InputGroup, Tabs, Tab } from 'react-bootstrap';
import { v4 as uuidv4 } from 'uuid';
import AdditionalCharges from './additional-charges';
import './index.css';
import BasicPrices from './basic-prices';
import { collection, doc, onSnapshot, query, setDoc, updateDoc } from 'firebase/firestore';
import { db } from '../../../../firebase';
import { toast } from 'react-toastify';
import { useAuth } from '../../../../context/AuthContext';

function Units({ allTowers, tower, state, unitMeasure, showUnitModal, handleCloseUnit }) {

  const { user } = useAuth();
  const { bid } = user.claims;

  const [isLoading, setIsLoading] = useState(false);
  const [wizIndex, setWizIndex] = useState('first');
  const [propID, setPropID] = useState(null);
  const [selectedTower, setSelectedTower] = useState(tower || null);
  const [units, setUnits] = useState({
    name: '',
    numUnit: '0',
    numFloors: '0',
    numUnitPerFloor: '0',
    unitNumberPerFloor: [],
    area: ''
  });

  const [unitNumbers, setUnitNumbers] = useState([]);
  const [isDuplicate, setIsDuplicate] = useState(false);
  const [basicPrice, setBasicPrice] = useState([]);
  const [additionalChargesData, setAdditionalChargesData] = useState([]);
  const [inputError, setInputError] = useState(null);

  function handleChange(e) {
    const { id, value } = e.target;
    setInputError({ ...inputError, [id]: '' });
    setUnits((prevData) => {
      return { ...prevData, [id]: value };
    });
  }

  useEffect(() => {
    if (tower) {
      setUnits({ ...units, numFloors: tower.numFloors });
    }

    if (state && state.item) {
      setPropID(state.id);
      setUnits({
        name: state.item.name,
        numUnit: state.item.numUnit,
        numFloors: tower.numFloors,
        numUnitPerFloor: state.item.numUnitPerFloor,
        unitNumberPerFloor: [...state.item.unitNumberPerFloor],
        area: state.item.area,
      });
      const tempUnitNumbersArray = Array.from(Array(Number(state.item.unitNumberPerFloor ? state.item.unitNumberPerFloor.length : 0)).keys());
      setUnitNumbers(tempUnitNumbersArray);
      setBasicPrice([...state.item.basicPrice]);
      setAdditionalChargesData([...state.item.additionalCharges]);
    }

  }, [tower, state, unitMeasure]);

  function handleResetForm() {
    setUnits({
      name: '',
      numUnit: '',
      area: '',
      bookings: []
    });
    setBasicPrice([]);
    setAdditionalChargesData([]);
    setInputError(null);
  }

  async function handleNewUnitData(propID, unitID, data) {
    try {
      await setDoc(doc(db, "Businesses", bid, "Properties", propID, "Units", unitID), data);
      setIsLoading(false);
    } catch (error) {
      console.log('Adding Unit Data [Error] : ', error);
      setIsLoading(false);
    }
  }

  async function handleUpdateUnitData(propID, unitID, data) {
    try {
      await updateDoc(doc(db, "Businesses", bid, "Properties", propID, "Units", unitID), data);
      setIsLoading(false);
      toast.success('Unit Updated, Successfully');
    } catch (error) {
      console.log('Updating Unit Data [Error] : ', error);
      setIsLoading(false);
    }
  }

  const handleParseData = () => {
    if (propID === null) {
      setIsLoading(true);
      let uuid = uuidv4();
      handleNewUnitData(state && state.id, uuid, {
        ...units,
        tower: selectedTower,
        basicPrice: basicPrice,
        additionalCharges: additionalChargesData
      });
      handleResetForm();
      setWizIndex('first');
      handleCloseUnit();
    } else {
      setIsLoading(true);
      handleUpdateUnitData(state && state.id, state && state.item && state.item.id, {
        ...units,
        tower: selectedTower,
        basicPrice: basicPrice,
        additionalCharges: additionalChargesData
      });
      handleResetForm();
      setWizIndex('first');
      handleCloseUnit();
    }
  }

  function handleWizardNext(value) {
    if (value === 'first') {
      const { name, area, numUnit } = units;
      if (!name) {
        setInputError({ ...inputError, name: 'This field is required.' });
      } else if (!area) {
        setInputError({ ...inputError, area: 'This field is required.' });
      } else if (!numUnit || (numUnit && numUnit === 0)) {
        setInputError({ ...inputError, numUnit: 'This field is required.', numFloors: 'This field is required.', numUnitPerFloor: 'This field is required.' });
      } else {
        setWizIndex('second');
      }
    }
  }

  function handleWizardBack(value) {
    if (value === 'second') {
      setWizIndex('first');
    }
  }

  const checkDuplicateChange = (item, event) => {
    var tempData = units && units.unitNumberPerFloor ? [...units.unitNumberPerFloor] : [];
    tempData[item] = { number: event.target.value };
    setUnits({ ...units, unitNumberPerFloor: tempData });
    var unitNumberArr = tempData && tempData.map((item) => item.number);

    var duplicateResponse = unitNumberArr.some((item, idx) => {
      return unitNumberArr.indexOf(item) !== idx;
    });

    setIsDuplicate(duplicateResponse);
  }

  return (
    <Modal
      show={showUnitModal}
      size='xl'
      onHide={handleCloseUnit}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>{propID && propID ? 'Edit Unit' : 'Add New Unit'}</Modal.Title>
      </Modal.Header>
      <Modal.Body className='p-0'>
        <div className='d-flex flex-column justify-content-between'>
          <div className='category-tabs bg-white'>
            <Tabs
              activeKey={wizIndex}
              className="mb-3 border-bottom"
              variant="pills"
              fill
            >
              <Tab eventKey="first" className='border-left-0 border-right-0' title="Basic Details">
                <div className='row p-3'>
                  <div className='col-md-6 col-12'>
                    <Form.Group className="mb-3" controlId="name">
                      <Form.Label>Name of Unit *</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter name of unit (e.g - P1, P2 or 2BHK, 3BHK etc.)"
                        onChange={handleChange}
                        className={inputError && inputError.name ? 'border-danger' : null}
                        value={units && units.name}
                        isInvalid={inputError && inputError.name}
                      />
                      <Form.Control.Feedback type="invalid">{inputError && inputError.name}</Form.Control.Feedback>
                    </Form.Group>
                  </div>
                  <div className='col-md-3 col-12'>
                    <Form.Group className="mb-3" controlId="area">
                      <Form.Label>Area (per Unit) *</Form.Label>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          placeholder="Enter area of a unit"
                          onFocus={(event) => event.target.select()}
                          onChange={handleChange}
                          className={inputError && inputError.area ? 'border-danger border-right-0' : 'border-right-0'}
                          value={units && units.area}
                          isInvalid={inputError && inputError.area}
                        />
                        <InputGroup.Text>{unitMeasure}</InputGroup.Text>
                      </InputGroup>
                    </Form.Group>
                  </div>
                  <div className='col-md-3 col-12'>
                    <Form.Group className="mb-3" controlId="area">
                      <Form.Label>Tower *</Form.Label>
                      <Form.Select
                        onChange={(event) => {
                          var tempSelected = allTowers && allTowers.find(x => x.id === event.target.value);
                          setSelectedTower(tempSelected);
                        }}
                        value={selectedTower && selectedTower.id}
                        isInvalid={inputError && inputError.tower}
                      >
                        <option>Select Tower</option>
                        {
                          allTowers && allTowers.map((tow, index) => {
                            return (
                              <option key={index} value={tow.id}>{tow.name}</option>
                            )
                          })
                        }
                      </Form.Select>
                    </Form.Group>
                  </div>

                  <div className='col-md-4 col-12'>
                    <Form.Group className="mb-3" controlId="numFloors">
                      <Form.Label>Total Floors *</Form.Label>
                      <Form.Control
                        disabled
                        value={units && units.numFloors}
                      />
                      <Form.Control.Feedback type="invalid">{inputError && inputError.numFloors}</Form.Control.Feedback>
                    </Form.Group>
                  </div>
                  <div className='col-md-4 col-12'>
                    <Form.Group className="mb-3" controlId="numUnitPerFloor">
                      <Form.Label>Total Unit (per Floor) *</Form.Label>
                      <Form.Control
                        type="number"
                        placeholder="0"
                        onFocus={(event) => event.target.select()}
                        onChange={(event) => {
                          let numUnit = parseFloat(selectedTower.numFloors ? selectedTower.numFloors : 0) * parseFloat(event.target.value ? event.target.value : 0);
                          setUnits({ ...units, numUnitPerFloor: event.target.value, numUnit });
                          setInputError({ ...inputError, numFloors: '', numUnitPerFloor: '', numUnit: '' });
                          if (event.target.value && event.target.value > 0) {
                            const tempArray = Array.from(Array(Number(event.target.value)).keys());
                            setUnitNumbers(tempArray);
                          } else {
                            setUnitNumbers([]);
                          }
                        }}
                        className={inputError && inputError.numUnitPerFloor ? 'border-danger' : null}
                        value={units && units.numUnitPerFloor}
                        isInvalid={inputError && inputError.numUnitPerFloor}
                      />
                      <Form.Control.Feedback type="invalid">{inputError && inputError.numUnitPerFloor}</Form.Control.Feedback>
                    </Form.Group>
                  </div>
                  <div className='col-md-4 col-12'>
                    <Form.Group className="mb-3" controlId="numUnit">
                      <Form.Label>Total Unit</Form.Label>
                      <Form.Control
                        disabled
                        type="text"
                        placeholder="0"
                        className={inputError && inputError.numUnit ? 'border-danger' : null}
                        value={units && units.numUnit}
                        isInvalid={inputError && inputError.numUnit}
                      />
                      <Form.Control.Feedback type="invalid">{inputError && inputError.numUnit}</Form.Control.Feedback>
                    </Form.Group>
                  </div>
                  {
                    units && units.numUnitPerFloor && units.numUnitPerFloor > 0 ?
                      <div className='mt-3'>
                        <div className='d-flex align-items-center justify-content-between mb-2'>
                          <h6>Unit Position (per Floor)</h6>
                          {
                            isDuplicate ?
                              <h6 className='text-danger'>
                                <small>Please do not enter duplicate value.</small>
                              </h6>
                              :
                              null
                          }
                        </div>
                        <div className='col-md-12 col-12'>
                          <div className='row'>
                            {
                              unitNumbers && unitNumbers.map((item, index) => {
                                return (
                                  <div key={index} className={units && units.numUnitPerFloor > 5 ? 'col-md-2 col-12' : 'col'}>
                                    <Form.Group className="mb-3 w-100 me-4">
                                      <Form.Label>Segment #{index + 1}</Form.Label>
                                      <InputGroup>
                                        <Form.Control
                                          type="number"
                                          size='sm'
                                          placeholder="e.g 1,2,3,4,5,6,7,8..."
                                          className={isDuplicate && isDuplicate ? 'border-danger' : ''}
                                          onFocus={(event) => event.target.select()}
                                          onChange={(event) => checkDuplicateChange(item, event)}
                                          isInvalid={isDuplicate && isDuplicate}
                                          value={units && units.unitNumberPerFloor && units.unitNumberPerFloor[index] && units.unitNumberPerFloor[index].number}
                                        />
                                      </InputGroup>
                                    </Form.Group>
                                  </div>
                                )
                              })
                            }
                          </div>
                        </div>
                      </div>
                      :
                      null
                  }
                </div>
                <BasicPrices
                  unitMeasure={unitMeasure}
                  basicPrice={basicPrice}
                  setBasicPrice={setBasicPrice}
                />
              </Tab>
              <Tab eventKey="second" className='border-left-0 border-right-0' title="Additional Charges">
                <AdditionalCharges unitMeasure={unitMeasure} setAdditionalChargesData={setAdditionalChargesData} additionalChargesData={additionalChargesData} />
              </Tab>
            </Tabs>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className='justify-content-between'>
        {
          wizIndex !== 'first' ?
            <Button
              variant='outline-danger'
              className='modal-button btn-width'
              onClick={() => handleWizardBack(wizIndex)}
            >
              BACK
            </Button>
            :
            <Button
              variant='danger'
              className='modal-button btn-width'
              onClick={() => handleResetForm()}
            >
              Reset
            </Button>
        }
        {
          wizIndex !== 'second' ?
            <Button
              variant='primary'
              className='modal-button btn-width'
              onClick={() => handleWizardNext(wizIndex)}
            >
              Next
            </Button>
            :
            <Button
              variant='primary'
              className='modal-button btn-width'
              onClick={handleParseData}
            >
              {propID && propID ? 'Update' : 'Save'}
            </Button>
        }
      </Modal.Footer>
    </Modal>
  );
}

export default Units;
